const states = {
  menuIsShow: true,
  title: 'title',
  isLoginState: true,
};

const mutations = {
  SET_TITLE(state, val) {
    state.title = val;
  },
  SET_MENU_IS_SHOW(state, val) {
    state.menuIsShow = val;
  },
  SET_LOGIN_STATE(state, val) {
    state.isLoginState = val;
  },
  RESET(state) {
    state.menuIsShow = true;
    state.title = 'title';
    state.isLoginState = true;
  },
};

const actions = {
  changeTitle({ commit }, val) {
    if (val && typeof val === 'string') {
      commit('SET_TITLE', val);
    }
  },
  changeMenuIsShow({ commit }, val) {
    console.log(typeof val === 'boolean');
    if ((val || val === false) && typeof val === 'boolean') {
      commit('SET_MENU_IS_SHOW', val);
    }
  },
  changeIsLoginState({ commit }, val) {
    if ((val || val === false) && typeof val === 'boolean') {
      commit('SET_LOGIN_STATE', val);
    }
  },
  reset({ commit }) {
    commit('RESET');
  },

};

const getters = {

};

export default {
  namespaced: true,
  state: states,
  mutations,
  actions,
  getters,
};
